/** The Home's demo users — the NETWORK half (the pure half is `demo.ts`). */

import { connectAsQuickConnect, listQuickConnect, type QuickConnectConfig } from '@agenticprimitives/connect-client';
import { api } from './api';
import { mapDemoPersonas, type DemoPersona } from './demo';
import type { AuthConfig } from './home';
import type { AppSession } from './types';

export function quickConnectConfig(config: AuthConfig): QuickConnectConfig {
  return { homeOrigin: config.home.origin, clientId: config.home.clientId };
}

export async function fetchDemoPersonas(config: AuthConfig): Promise<DemoPersona[]> {
  if (!config.home.origin || !config.home.clientId) return [];
  return mapDemoPersonas(await listQuickConnect(quickConnectConfig(config)));
}

export async function connectAsDemoUser(config: AuthConfig, handle: string): Promise<AppSession> {
  const result = await connectAsQuickConnect(quickConnectConfig(config), handle);
  const session = await api.demoLogin({ idToken: result.idToken, delegation: result.delegation, authOrigin: config.home.origin });
  return { token: session.token, personId: session.personId, name: session.name, via: 'demo', address: session.address, agentName: session.agentName };
}
